import { render } from "./undecorated-link.vue?vue&type=template&id=33de2428"
import script from "./undecorated-link.vue?vue&type=script&lang=js"
export * from "./undecorated-link.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__